/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';

import { Namespaces } from '../../i18n';
import { useDocumentTitle } from '../../utils/useDocumentTitle';
import { useScrollToTopOnMount } from '../../utils/useScrollToTopOnMount';
import { createAboutPageStyles } from './AboutPage.styles';
import { AboutUsSection } from './components/AboutUsSection/AboutUsSection';
import { FooterSection } from './components/FooterSection/FooterSection';
import { HeaderSection } from './components/HeaderSection/HeaderSection';
import { OurMissionSection } from './components/OurMissionSection/OurMissionSection';
import { OurOfficesSection } from './components/OurOfficesSection/OurOfficesSection';
import { OurValuesSection } from './components/OurValuesSection/OurValuesSection';
import { ServicesSection } from './components/ServicesSection/ServicesSection';
import { StatisticsSection } from './components/StatisticsSection/StatisticsSection';

export const AboutPage = memo(() => {
  const classes = createAboutPageStyles();
  const { t } = useTranslation(Namespaces.Common);
  useDocumentTitle(t('page_titles.about'));
  useScrollToTopOnMount();

  return (
    <Grid container className={classes.root}>
      <HeaderSection />
      <AboutUsSection />
      <OurValuesSection />
      <OurMissionSection />
      <StatisticsSection />
      <ServicesSection />
      <OurOfficesSection />
      <FooterSection />
    </Grid>
  );
});
